import React from 'react'
import { useSelector } from 'react-redux'

export default function useActiveGame() {
    const activeGame = useSelector((state) => state.gameTable.activeGame);

    return activeGame
}
